import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetRegistrationsValidForCertificates, GetRegistrationsValidForCertificatesResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetRegistrationsValidForCertificatesResponse, GetRegistrationsValidForCertificatesResponse>) => response?.data?.registrations;

const getError = (response?: SWRResponse<GetRegistrationsValidForCertificatesResponse, GetRegistrationsValidForCertificatesResponse>) => (response?.error ?? response?.data);

const getAdditionalState = (response?: SWRResponse<GetRegistrationsValidForCertificatesResponse, GetRegistrationsValidForCertificatesResponse>) => ({
    registrations: response?.data?.registrations
});

export const useCertificateRegistrations = (id?: number, configuration?: SWRConfiguration) => {

    const request = useMemo(() => {

        return () => {
            return new GetRegistrationsValidForCertificates({});
        };
    }, [id])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useCertificateRegistrations;
